export const MAX_NOTIFICATIONS_IN_POPUP = 4;
